import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-[#1e3a5f] text-white shadow-lg border-b border-[#d4a574]/20" data-id="element-376">
      {/* Desktop Header */}
      <div className="hidden sm:block" data-id="element-377">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-center" data-id="element-378">
          <div className="flex items-center gap-3" data-id="element-379">
            <div className="flex items-center gap-2" data-id="element-380">
              <Sparkles className="w-4 h-4 text-[#d4a574]" data-id="element-381" />
              <span className="bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-382">
                Oferta de Lanzamiento
              </span>
            </div>
            <p className="text-sm font-medium" data-id="element-383">
              Precio especial por tiempo limitado{' '}
              <span className="text-[#d4a574]" data-id="element-384">- ¡Ahorra un 80% hoy!</span>
            </p>
          </div>
        </div>
      </div>

      {/* Mobile Header - Optimized */}
      <div className="sm:hidden" data-id="element-385">
        <div className="px-3 py-3 text-center" data-id="element-386">
          <div className="flex items-center justify-center gap-1.5 mb-2" data-id="element-387">
            <Sparkles className="w-3.5 h-3.5 text-[#d4a574] flex-shrink-0" data-id="element-388" />
            <span className="bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-389">
              Oferta Lanzamiento
            </span>
          </div>
          <p className="text-xs font-medium text-gray-200" data-id="element-390">
            Precio especial{' '}
            <span className="text-[#d4a574] font-bold" data-id="element-391">- ¡80% OFF!</span>
          </p>
        </div>
      </div>
    </motion.header>;
}